import { message } from 'antd';
import { AuthService } from '../../services';
import { setCookie } from '../../utils/cookies';
import COOKIES_STORAGE from '../../configs/cookiesStorage';

const { COOKIES, LOCAL_STORAGE } = COOKIES_STORAGE;

const onSwitchAccountHandler = async (params) => {
  const { body, setIsLoadingSwitch, onRedirectToLandingPage } = params;
  try {
    setIsLoadingSwitch(true);
    const response = await AuthService.switchTeam(body);
    const { token, user } = response.data;

    const roleFiltered = user.roles.filter((role) => {
      return role.scope === 1;
    });

    const teamRole = user.team.team_role?.groups;
    const rules = roleFiltered[0].groups;

    localStorage.clear();

    localStorage.setItem(LOCAL_STORAGE.USER_RULES, JSON.stringify(rules));
    localStorage.setItem(LOCAL_STORAGE.TEAM_ROLE, JSON.stringify(teamRole));

    delete roleFiltered[0].groups;
    delete user.roles;
    delete user.team.team_role;

    user.roles = roleFiltered;

    setCookie(COOKIES.USER_DATA, JSON.stringify(user), 1000);
    setCookie(COOKIES.TOKEN, JSON.stringify(token), 1000);
    await message.success('Successfully changed team');
    onRedirectToLandingPage();
  } catch {
    message.error('Failed to change team');
  } finally {
    setIsLoadingSwitch(false);
  }
};

export const onLogoutHandler = async (params) => {
  const { setIsLoadingLogout } = params;
  const token = AuthService.getDeviceToken();
  setIsLoadingLogout(true);
  await AuthService.postLogout({ device_token: token });
  await message.success('Sign out success');
  await AuthService.logout();

  setIsLoadingLogout(false);
};

export default onSwitchAccountHandler;
